module.exports = __webpack_public_path__ + "static/media/HUIDA_MUERTE_CACIQUE.5891407c.jpg";